function getTutorialVideoThumb(youtubeVideoLink) {

    const videoId = youtubeVideoLink?.slice(youtubeVideoLink.indexOf('=')+1, youtubeVideoLink.length)
    return (`https://img.youtube.com/vi/${videoId}/0.jpg`);
}

export default getTutorialVideoThumb;